import i18n from "@/i18n/index";

export const noDataCatToShow = state => (
    !state.items
        || (state.items && state.items.length === 0)
        || (state.items && state.items.length === 1 && state.items[0].removed)
);

export const items = state => state.items;

export const selectedCatalogName = state => state.selectedCat.name;

export const selectedCatalogData = state => state.selectedCatalogData;

export const getDeleteCatAction = state => state.deleteCatAction;

export const columns = state => state.columns;

export const copyCatalogList = state => state.copyCatalogList;

export const selectedCat = state => state.selectedCat;

export const getNewCatalog = state => state.newCatalog;

export const unsavedChanges = state => state.unsavedChanges;

export const catalogsAlreadySaved = state => state.catalogsAlreadySaved;

export const dataFromImport = state => state.dataFromImport;

export const getFromImportExcel = state => state.fromImportExcel;

export const currApp = state => state.currApp;

export const fromCatList = state => state.fromCatList;

export const columnsForData = state => state.columnsForData;

export const inEditCatalogColumns = state => state.inEditCatalogColumns;

export const columnDataTypesDDL = state => state.columnDataTypes;

export const columnDataTypesWithAttDDL = state => state.columnDataTypesWithAttach;

export const existingCatalogsAsList = state => {
    const options = [
        {
            label: i18n.t("catalogs.name").toUpperCase(),
            value: "cts",
            itemDisabled: true,
            className: "bg-grey-color f-pl-md"
        }
    ];
    if (state.items) {
        options.push(
            ...state.items.map(catalog => ({
                label: catalog.name,
                value: catalog.name,
                isExstCat: true,
                removed: catalog.removed,
                className: "f-pl-lg list-items-popover"
            }))
        );
    }

    return options;
};

export const temporaryColumnsCache = state => state.temporaryColumnsCache;
export const getMasterId = state => state.masterId;
export const getCommitId = state => state.commitId;
export const getDataModelList = state => state.dataModelList;
